/**
 * The LPA's bounding box [west, south, east, north], rendered by page.njk into
 * #lpa-bounds when the tenant has a boundary configured. Null otherwise.
 * @returns {[number, number, number, number] | null}
 */
export function readLpaBounds() {
  const el = document.getElementById('lpa-bounds')
  if (!el?.textContent) {
    return null
  }

  try {
    const bounds = JSON.parse(el.textContent)
    return Array.isArray(bounds) &&
      bounds.length === 4 &&
      bounds.every(Number.isFinite)
      ? bounds
      : null
  } catch {
    return null
  }
}

/**
 * How far users can pan: the LPA's bounding box plus a margin of half its
 * larger side all round. MapLibre won't show anything outside maxBounds, so
 * without the margin it would zoom in and crop the LPA to fill the map.
 * @param {[number, number, number, number]} bounds
 * @returns {[number, number, number, number]}
 */
export function toMaxBounds([west, south, east, north]) {
  const margin = Math.max(east - west, north - south) / 2
  return [west - margin, south - margin, east + margin, north + margin]
}
